import { createUseStyles } from 'react-jss'

export const style = {
  title: {
    composes: 'h1 report-full-width',
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: 3,
    fontSize: 28,
    fontWeight: 'bold',
    margin: '0 auto 15px'
  }
}

export const useStyles = createUseStyles(style)
